import { MerchantCountry, MerchantBusinessType } from "./stripe";

// The payout provider that settles a merchant. Mirrors the backend
// `moneySettlementPlatformId` (see moneySettlement_util.ts).
export type SettlementPlatform = "stripe" | "column";
export type SettlementCountry = "US" | "GR";
export type SettlementCurrency = "usd" | "eur";
export type SettlementCurrencyUnit = "USD" | "EURO";
export type SettlementCurrencySign = "$" | "€";

export const CURRENCY_BY_COUNTRY: Record<
  SettlementCountry,
  SettlementCurrency
> = {
  US: "usd",
  GR: "eur",
};

export const CURRENCY_UNIT_BY_COUNTRY: Record<
  SettlementCountry,
  SettlementCurrencyUnit
> = {
  US: "USD",
  GR: "EURO",
};

export const CURRENCY_SIGN_BY_COUNTRY: Record<
  SettlementCountry,
  SettlementCurrencySign
> = {
  US: "$",
  GR: "€",
};

// One row in the setup modal's "payout destination" dropdown: a country paired
// with the platform that settles it. Greece is Stripe-only; Column is US rails.
export interface PayoutDestinationOption {
  value: string; // stable key, e.g. "US-column"
  label: string; // "United States — Column"
  country: MerchantCountry;
  platform: SettlementPlatform;
}

// What the setup modal returns on Continue.
export interface PayoutDestinationSelection {
  country: MerchantCountry;
  platform: SettlementPlatform;
  businessType: MerchantBusinessType;
}
